import { DEFAULT_SKU_RANK } from "../contants";

export const SET_NAME = "SET_NAME";
export const SET_CODE = "SET_CODE";
export const SET_PRODUCT_LINE_CODE = "SET_PRODUCT_LINE_CODE";
export const SET_SP_CODE = "SET_SP_CODE";
export const SET_END_DATE = "SET_END_DATE";
export const SET_DESCRIPTION = "SET_DESCRIPTION";
export const SET_SKU = "SET_SKU";
export const ADD_SKU = "ADD_SKU";
export const EDIT_SKU = "EDIT_SKU";
export const REMOVE_SKU = "REMOVE_SKU";

export const initialState = {
  name: "",
  code: "",
  productLineCode: "",
  spCode: "",
  endDate: "",
  description: "",
  skus: [DEFAULT_SKU_RANK],
};
